import styled from 'styled-components';

import { color, font } from 'utils/styles';

export const InfoLabel = styled.div`
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.size(12.5)}
  ${font.bold}
`;

export const InfoValue = styled.div`
  ${font.size(15)}
  ${font.medium}
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const InfoValueSmall = styled.div`
  ${font.size(14)}
  ${font.medium}
`;

export const EmptyLabel = styled.div`
  color: ${color.textMedium};
  ${font.size(12.5)}
  ${font.bold}
`;

export const Actions = styled.div`
  display: flex;
  padding-top: 12px;
  & > button {
    margin-right: 6px;
  }
`;
